import { render } from "./person.vue?vue&type=template&id=798cee32"
import script from "./person.vue?vue&type=script&lang=js"
export * from "./person.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__